import PetOrderAPI from "@/app/apis/main/pet-order/pet-order-api";

export default {
  /**
   * @param {object} purchaseDetails
   */
  async addPetPurchase(purchaseDetails) {
    return PetOrderAPI.addPetPurchase(purchaseDetails);
  },

  /**
   * @param {object} requestPurchaseDetails
   */
  async requestPurchase(requestPurchaseDetails) {
    return PetOrderAPI.requestPurchase(requestPurchaseDetails);
  },

  /**
   * @params {Object} purchaseDetails
   * */
  async getPetPurchase(purchaseDetails) {
    return PetOrderAPI.getPetPurchase(purchaseDetails);
  },

  /**
   * @params petOrderId
   * */
  async deletePetOrder(petOrderId) {
    return PetOrderAPI.deletePetOrder(petOrderId);
  },

  /**
   * @params {Object} purchaseDetails
   * */
  async getDogPurchase(referenceId) {
    return PetOrderAPI.getDogPurchase(referenceId);
  },

  /**
   * @params {Integer} dogPurchaseId
   * @params {Object} requestDetails
   * */
  async requestRefund(dogPurchaseId, requestDetails) {
    return PetOrderAPI.requestRefund(dogPurchaseId, requestDetails);
  },

  /**
   * @params integer dogPurchaseId
   * @params {Object} details
   * */
  async cancelDogPurchase(dogPurchaseId, details) {
    return PetOrderAPI.cancelDogPurchase(dogPurchaseId, details);
  },

  /**
   * @params {Object} dogPurchaseDetails
   * */
  async addDogPurchasePet(dogPurchaseDetails) {
    return PetOrderAPI.addDogPurchasePet(dogPurchaseDetails);
  },
};
